import { ReadingInfo } from "app/ngs-types/reading-info";

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  COMPONENTS_ROOT: 'ngs', //name of the the route param in the url. e.g.: ngs/atado/kalmanhaza
  ROOT: 'https://ngsalloc.appspot.com'
  //ROOT: 'http://localhost:4200'
};

export const ATADOMAP = {
  'kalmanhaza': 'HATELJCS11EN',
  'kotaj': 'MINYIRTE15GN',
  'nadudvar': 'HANADUDV11GN',
  'bodonhat' : 'HABODONH1VEN'
};

export const HAL_PONT_NEV = {
  "HABODONH1VEN" : "Bödönhát",
  "HANADUDV11GN" : "Nádudvar",
  "MINYIRTE15GN" : "Kótaj",
  "HATELJCS11EN" : "Kálmánháza"
};


export const LOGTYPES = [
  { value: 'UGYFELCSERE', displayValue: 'Ügyfélcsere' },
  { value: 'ELLENORZES', displayValue: 'Mérőhely ellenőrzés' },
  { value: 'UZEMZAVAR', displayValue: 'Üzemzavar' },
  { value: 'MEROCSERE', displayValue: 'Mérőcsere'},
  { value: 'KERVALTAS', displayValue: 'Kereskedő Váltás' },
  { value: 'LEOLVASAS', displayValue: 'Leolvasás' },
  { value: 'KIKAPCSOLAS', displayValue: 'Kikapcsolás' },
  { value: 'BEKAPCSOLAS', displayValue: 'Vissza Kapcsolás'}
];

export const PROFILS = ["L1", "L2", "L3", "U1", "U2", "U3"];

export const CAPACITIES = [
  { value: '<20', displayValue: '< 20m3'},
  { value: '20-100', displayValue: '20 - 100 m3'},
  { value: '100-500', displayValue: '100 - 500 m3'},
  { value: '500<', displayValue: '500 m3 <'}
];

export const CONSUMERTYPES = ["Egyetemes", "Nem egyetemes"];


// order of csv export
export const ORDER = {
  "HANADUDV11GN" : ["HUFMASZ", "HUFE2HUN", "HUFFOGAZESZ"]
}

export const KERESKEDOK = [
                          'HUFMASZ',
                          'HUFTIGAZ',
                          'HUFE2HUN',
                          'HUFFOGAZ',
                          'HUFTIGAZESZ',
                          'HUFMOLKER',
                          'HUFEONENR',
                          'HUFFOGAZESZ',
                          'HUFHUNGAROE',
                          'HUFFOGAZPAR',
                          'HUFMFGK',
                          'HUFEMOGA',
                          'HUFCYEB',
                          'HUFENMEGOLD',
                          'HUFEMVIA',
                          'GREGHU',
                          'HUFNORDEST',
                          'HUFWATTLER',
                          'HUFPPD',
                          'HUFCYEBEK'];

export const SZALLITO_MAP = {
  "HUFCYEBEK" : "HUFCYEBEM",
  "HUFFOGAZESZ" : "HUFMFGK",
  "HUFFOGAZPAR" : "HUFMFGK",
  "HUFFOGAZ" : "HUFMFGK",
  "HUFEMOGA" : "HUFEMOGA",
  "HUFEONENR" : "HUFEONENR",
  "HUFENMEGOLD" : "HUFENMEGOLD",
  "HUFMOLKER" : "HUFMOLKER",
  "HUFMASZ" : "HUFMASZ",
  "HUFE2HUN" : "HUFE2HUN",
  "GREGHU" : "AUFNITROFER",
  "AUFNITROFER": "GREGHU",
  "HUFEMVIA" :"HUFEMVIA",
  "HUFNORDEST" : "HUFNORDEST",
  "HUFWATTLER" : "HUFWATTLER",
  "HUFPPD" : "HUFPPD"
}


//elszamolasi forma, naponta podonkent, vagy havonta
export const CALCMAP = {
  'bodonhat' : 'napi',
  'nadudvar' : 'havi'
}


export const LEOLMAP = {
  'kalmanhaza': new ReadingInfo(new Set(), new Map(), new Map()),
  'kotaj': new ReadingInfo(new Set(), new Map(), new Map()),
  'nadudvar': new ReadingInfo(new Set(['39N082578862000N',"39N082578862000N-2",'39N082578864000D','39N082578863000I-1']), 
                              new Map([["39N082578862000N", 0.1]]),
                              new Map([["39N082578862000N", "Nádudvari Agrokémiai Kft. - Mero 60"],
                                      ["39N082578862000N-2", "Nádudvari Agrokémiai Kft. - (Mero: 400)"],
                                      ["39N082578864000D", "KITE ZRt. - (Mero: 160)"],
                                      ["39N082578863000I-1", "POLYDUCT ZRT - (Mero: 250)"]])
  ),
  'bodonhat': new ReadingInfo(
        new Set(['39N081043981003K','39N0881042294007B', '39N0810431620055', '39N081018001009W', '39N081044511008Z', '39N081020619010E', '39N0810400200014']),
        new Map([["39N0810431620055", 0.035], 
                 ["39N081042294007B", 0.04]]),
        new Map([["39N081043981003K", "Denburg Hungária Kft. "], ["39N0810400200014", "SYNERGY"]])
  )
};




// WEBPACK FOOTER //
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/environments/environment.ts